import React, { useContext, useEffect, useRef, useState } from "react";
import "./Product_Image.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "react-medium-image-zoom/dist/styles.css";
import { Context } from "../../../utils/context";

const Product_Image = ({ variant,selectedImage,setSelectedImage }) => { 
  const images = [
    "/assest/luxury_images/festival_products/img3.png",
    "/assest/luxury_images/festival_products/img5.png",
    "/assest/luxury_images/gifts/img3.png",
    "/assest/luxury_images/festival_products/img3.png",
    "/assest/luxury_images/gifts/img2.png",
    "/assest/luxury_images/gifts/img3.png",
    "/assest/luxury_images/gifts/img3.png",
  ];

  const { IMG_URL } = useContext(Context);
 
  const [swiperInstance, setSwiperInstance] = useState(null);
  const handleImageClick = (imageSrc) => {
    console.log(imageSrc, "imageSrc  imageSrc");

    setSelectedImage(imageSrc);
  };

  class Zoomable {
    constructor(element, config) {
      this.element = element;
      this.config = this._mergeConfig(config);

      const { initialZoom, minZoom, maxZoom } = this.config;

      this.zoomed = false;
      this.initialZoom = Math.max(Math.min(initialZoom, maxZoom), minZoom);
      this.zoom = this.initialZoom;

      this.img = element.querySelector(".zoomable__img");
      this.img.draggable = false;
      this.element.style.setProperty("--zoom", this.initialZoom);

      this._addEventListeners();
    }

    static get Default() {
      return Default;
    }

    _addEventListeners() {
      this.element.addEventListener("mouseenter", () =>
        this._handleMouseover(),
      );
      this.element.addEventListener("mousemove", (evt) =>
        this._handleMousemove(evt),
      );
      this.element.addEventListener("mouseleave", () => this._handleMouseout());
      this.element.addEventListener("wheel", (evt) => this._handleWheel(evt));
    }

    _handleMouseover() {
      if (this.zoomed) {
        return;
      }

      this.element.classList.add("zoomable--zoomed");
      this.zoomed = true;
    }

    _handleMousemove(evt) {
      if (!this.zoomed) {
        return;
      }

      const elPos = this.element.getBoundingClientRect();
      const percentageX = `${((evt.clientX - elPos.left) * 100) /
        elPos.width}%`;
      const percentageY = `${((evt.clientY - elPos.top) * 100) /
        elPos.height}%`;

      this.element.style.setProperty("--zoom-pos-x", percentageX);
      this.element.style.setProperty("--zoom-pos-y", percentageY);
    }

    _handleMouseout() {
      if (!this.zoomed) {
        return;
      }

      this.element.style.setProperty("--zoom", this.initialZoom);
      this.element.classList.remove("zoomable--zoomed");
      this.zoomed = false;
    }

    _handleWheel(evt) {
      if (!this.zoomed) {
        return;
      }

      evt.preventDefault();

      const newZoom = this.zoom + evt.deltaY * (this.config.zoomSpeed * -1);
      const { minZoom, maxZoom } = this.config;

      this.zoom = Math.max(Math.min(newZoom, maxZoom), minZoom);
      this.element.style.setProperty("--zoom", this.zoom);
    }

    _mergeConfig(config) {
      return {
        ...this.constructor.Default,
        ...(typeof config === "object" ? config : {}),
      };
    }
  }

  const Default = {
    initialZoom: 3,
    minZoom: 1.25,
    maxZoom: 4,
    zoomSpeed: 0.01,
  };

  const zoomableRef = useRef(null);

  useEffect(() => {
    const element = zoomableRef.current;
    if (!element) return;

    const zoomable = new Zoomable(element);

    return () => {
      element.removeEventListener("mouseenter", zoomable._handleMouseover);
      element.removeEventListener("mousemove", zoomable._handleMousemove);
      element.removeEventListener("mouseleave", zoomable._handleMouseout);
      element.removeEventListener("wheel", zoomable._handleWheel);
    };
  }, []);

  const [isMobile, setIsMobile] = useState(window.innerWidth < 575);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 575);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <section className="Product_Image">
      <div className="row">
        <div className="col-lg-2 col-sm-3 order-sm-1 order-2">
          <div className="verticle_swiper_div">
            <Swiper
              slidesPerView={"auto"}
              modules={[Autoplay]}
              onSwiper={(swiper) => setSwiperInstance(swiper)}
              direction={isMobile ? "horizontal" : "vertical"}
              className="verticleSwiper"
              breakpoints={{
                0: {
                  slidesPerView: 5,
                  spaceBetween: 10,
                },
                370: {
                  slidesPerView: 5,
                  spaceBetween: 10,
                },
                485: {
                  slidesPerView: 5,
                  spaceBetween: 10,
                },
                575: {
                  slidesPerView: 4,
                  spaceBetween: 30,
                },

                768: {
                  slidesPerView: 4,
                  spaceBetween: 20,
                },
                992: {
                  slidesPerView: 5,
                  spaceBetween: 30,
                },
                1024: {
                  slidesPerView: 4,
                  spaceBetween: 30,
                },
                1200: {
                  slidesPerView: 5,
                  spaceBetween: 20,
                },
                1440: {
                  slidesPerView: 6,
                  spaceBetween: 20,
                },
                2000: {
                  slidesPerView: 6,
                  spaceBetween: 20,
                },
              }}
              pagination={{ clickable: true }}
            >
              {variant?.product_images?.map((slide, index) => (
                <SwiperSlide key={index}>
                  <div
                    className="img_container"
                    onClick={() => handleImageClick(IMG_URL+slide?.image)}
                  >
                    <img src={IMG_URL + slide?.image} className="prod_img" />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
        <div className="col-lg-10 col-sm-9 order-sm-2 order-1">
          <div className="big_img_holder">
            <div ref={zoomableRef}>
              <img
                src={selectedImage}
                className="zoomable__img inner_img"
                alt="Selected"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Product_Image;
